<template>
  <div class="record-wrapper">
    <template v-if="dataDone && binded">
    <div class="record-back" v-if="dataDone"></div>
    <div class="record-main" v-if="dataDone">
      <div class="record-header">
        <div class="header-card">
          <div class="base-info">
            <div class="info-box">
              <div class="avatar-info">
                <div class="avatar"><img :src="patientBaseInfo.avatar"></div>
                <div class="name">
                  <h4>{{patientBaseInfo.username}}</h4>
                  <p>{{patientBaseInfo.gender | genderFilter}} <span class="from-province">{{patientBaseInfo.province}}</span></p>
                </div>
              </div>
            </div>
            <div class="review" v-if="patientBaseInfo.count > 0">复诊次数：{{patientBaseInfo.count}}次</div>
          </div>
          <div class="patient-info">
            <div class="info-item">
              <div class="number">{{patientBaseInfo.birthday | ageFilter('number')}}</div>
              <div class="info-type">年龄</div>
            </div>
            <div class="info-item">
              <div class="number">{{parseFloat(patientBaseInfo.stature) || '-'}}</div>
              <div class="info-type">身高 (cm)</div>
            </div>
            <div class="info-item">
              <div class="number">{{parseFloat(patientBaseInfo.weight) || '-'}}</div>
              <div class="info-type">体重 (kg)</div>
            </div>
            <div class="info-item">
              <div class="number">{{patientBaseInfo.BMI || '-'}}</div>
              <div class="info-type">BMI</div>
            </div>
          </div>
          <div class="other-info-box">
            <div class="other-info" v-if="patientBaseInfo.allergy">
              <div class="type">过敏史</div>
              <div class="content">{{patientBaseInfo.allergy == '否认' ? '无过敏史' : patientBaseInfo.allergy == '不确定' ? '不确定过敏史' : patientBaseInfo.allergy}}</div>
            </div>
            <div class="other-info-more" v-show="openedInfo">
              <div class="other-info" v-if="patientBaseInfo.is_married != 3">
                <div class="type">婚况</div>
                <div class="content">{{patientBaseInfo.is_married | marriageFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.is_childbed != 3">
                <div class="type">是否生育</div>
                <div class="content">{{patientBaseInfo.is_childbed | whetherFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.nation">
                <div class="type">民族</div>
                <div class="content">{{patientBaseInfo.nation}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.job">
                <div class="type">职业</div>
                <div class="content">{{patientBaseInfo.job}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.is_smoke != 3">
                <div class="type">是否吸烟</div>
                <div class="content">{{patientBaseInfo.is_smoke | whetherFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.is_drink != 3">
                <div class="type">是否喝酒</div>
                <div class="content">{{patientBaseInfo.is_drink | whetherFilter}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.gen_disease">
                <div class="type">家族遗传病史</div>
                <div class="content">{{patientBaseInfo.gen_disease}}</div>
              </div>
              <div class="other-info" v-if="patientBaseInfo.ser_disease">
                <div class="type">既往重大疾病史</div>
                <div class="content">{{patientBaseInfo.ser_disease}}</div>
              </div>
            </div>
          </div>
          <div class="toggle-arrow" :class="{'close': openedInfo}" @click="openedInfo = !openedInfo" v-if="showMoreInfo"><span>{{openedInfo ? '收起' : '展开全部'}}</span><icon icon-class="arrow"></icon></div>
        </div>
      </div>
      <div class="medical-record-wrapper">
        <h2>归档病历</h2>
        <div class="record-list">
          <div class="record-item-box" v-for="(item, index) in records" :key="index">
            <!-- 病历 -->
            <div class="record-item" v-if="item.type == 3">
              <div class="record-top">
                <div class="title">{{item.p_dep_title}} - {{item.dep_title}}</div>
                <div class="date">{{item.create_time | dateFilter}}</div>
                <div class="review-status" v-if="item.status == 4"><img src="@/assets/images/review.png"></div>
                <div class="review-status" v-else-if="item.status == 5"><img src="@/assets/images/review-unpass.png"></div>
                <div class="review-status" v-else><img src="@/assets/images/review-pass.png"></div>
              </div>
              <div class="record-content">
                <div class="content-item">
                  <div class="item-type">主诉</div>
                  <div class="item-content">{{item.self_reported}}</div>
                </div>
                <div class="content-item">
                  <div class="item-type">诊断</div>
                  <div class="item-content">{{item.diagnose}}</div>
                </div>
                <div class="content-item">
                  <div class="item-type">开方人</div>
                  <div class="item-content">{{item.doctor_username}} (医生)</div>
                </div>
              </div>
              <!-- 审核中和审核不通过的非本医生处方不显示详情 -->
              <div v-if="(item.status == 4 || item.status == 5) && item.doc_id != userInfo.user_id" style="height: 46px;"></div>
              <div class="to-detail" @click="toDetail(item)" v-else>
                <span>查看详情<icon icon-class="arrow"></icon></span>
              </div>
            </div>
            <!-- 问诊单 -->
            <div class="record-item" v-if="item.type == 2">
              <div class="record-top">
                <div class="title">问诊单 - {{item.p_dep_title}} - {{item.dep_title}}</div>
                <div class="date">{{item.create_time | dateFilter}}</div>
              </div>
              <div class="to-detail" @click="toDetail(item)">
                <span>查看详情<icon icon-class="arrow"></icon></span>
              </div>
            </div>
            <!-- 首诊记录 -->
            <div class="record-item" v-if="item.type == 1">
              <div class="record-top">
                <div class="title">{{item.p_dep_title}} - {{item.dep_title}}<span>线下就诊</span></div>
                <div class="date">{{item.create_time | dateFilter}}</div>
              </div>
              <div class="to-detail" @click="toDetail(item)">
                <span>查看详情<icon icon-class="arrow"></icon></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
    <div class="error-page questionnaire" v-if="dataDone && !binded">
      <icon icon-class="fail"></icon>
      <p>此患者已与您解绑，无法查看ta的病历</p>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .record-wrapper{
    position: relative;
    margin-top: 44px;
    .record-back{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 184px;
      background: @xile;
      z-index: 1;
    }
    .record-main{
      position: relative;
      z-index: 10;
      padding-top: 16px;
      .record-header{
        padding: 0 16px;
        .header-card{
          position: relative;
          width: 100%;
          border-radius: 6px;
          box-shadow: 0px 4px 10px 0px rgba(0,132,138,0.08);
          background: #FFF;
          padding: 24px 16px 32px;
          .base-info{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            .avatar-info{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .avatar{
                width: 48px;
                height: 48px;
                overflow: hidden;
                border-radius: 50%;
                img{
                  width: 100%;
                }
              }
              .name{
                color: @black;
                margin-left: 12px;
                max-width: 150px;
                h4{
                  margin-top: 4px;
                  font-size: 18px;
                  line-height: 21px;
                  font-weight: bold;
                  max-width: 100%;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow-x: hidden;
                }
                p{
                  margin-top: 8px;
                  font-size: 14px;
                  line-height: 14px;
                  .from-province{
                    margin-left: 10px;
                    font-size: 14px;
                    color:#666666;

                  }
                }
              }
            }
            .review{
              height: 22px;
              display: flex;
              justify-content: center;
              padding: 0 8px;
              font-size: 12px;
              line-height: 22px;
              color: #666;
              border: 1px solid #999;
              border-radius: 13px;
              white-space: nowrap;
              margin-top: 1px;
            }
          }
          .patient-info{
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            padding: 24px 0 15px;
            border-bottom: 1px solid #EEE;
            color: @black;
            text-align: center;
            .info-item{
              .number{
                font-size: 18px;
                line-height: 23px;
              }
              .info-type{
                color: #666;
                margin-top: 12px;
                font-size: 14px;
                line-height: 14px;
              }
            }
          }
          .other-info-box{
            padding-top: 16px;
            .other-info-more{
              margin-top: 24px;
            }
            .other-info{
              margin-top: 24px;
              &:first-child{
                margin-top: 0;
              }
              .type{
                font-size: 14px;
                line-height: 14px;
                color: @black;
                font-weight: bold;
              }
              .content{
                margin-top: 8px;
                font-size: 14px;
                line-height: 20px;
                color: #666;
              }
            }
          }
          .toggle-arrow{
            position: absolute;
            bottom: 4px;
            left: 0;
            width: 100%;
            height: 24px;
            font-size: 12px;
            color: #999;
            display: flex;
            justify-content: center;
            align-items: center;
            span{
              margin-right: 4px;
            }
            svg{
              transform: rotate(90deg) translateX(-1px);
            }
            &.close{
              svg{
                transform: rotate(-90deg) translateX(-2px);
              }
            }
          }
        }
      }
      .medical-record-wrapper{
        width: 100%;
        background: #FFF;
        h2{
          margin-top: 24px;
          line-height: 20px;
          padding: 0 20px 12px;
          font-size: 18px;
          color: @black;
          font-weight: bold;
        }
        .record-list{
          width: 100%;
          .record-item{
            border-top: 6px solid #F7F7F7;
            padding: 0 20px;
            .record-top{
              position: relative;
              padding: 20px 0 12px;
              display: flex;
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              border-bottom: 1px solid #EEE;
              .title{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                font-size: 15px;
                line-height: 20px;
                font-weight: bold;
                color: @black;
                span{
                  height: 20px;
                  border: 1px solid #999;
                  border-radius: 13px;
                  line-height: 20px;
                  font-size: 12px;
                  color: #666;
                  padding: 0 8px;
                  margin-left: 8px;
                  font-weight: normal;
                }
              }
              .date{
                margin-top: 6px;
                font-size: 14px;
                line-height: 14px;
                color: #999;
              }
              .review-status{
                position: absolute;
                bottom: 10px;
                right: -4px;
                height: 44px;
                img{
                  height: 100%;
                }
              }
            }
            .record-content{
              .content-item{
                margin-top: 20px;
                font-size: 14px;
                line-height: 14px;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
                .item-type{
                  position: relative;
                  color: #666;
                  width: 55px;
                  flex-shrink: 0;
                  text-align-last: justify;
                }
                .item-content{
                  margin-left: 25px;
                  color: @black;
                }
              }
            }
            .to-detail{
              display: flex;
              justify-content: flex-end;
              align-items: center;
              height: 46px;
              span{
                font-size: 14px;
                line-height: 14px;
                color: #666;
                display: flex;
                align-items: center;
                svg{
                  font-size: 12px;
                  color: #666;
                }
              }
            }
          }
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        binded: true,
        showMoreInfo: false,
        openedInfo: false,
        patientBaseInfo: {},
        records: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      // 判断是否与医生解绑
      this.$root.post('/isBind', {
        doc_id: this.userInfo.user_id,
        pat_id: this.$route.params.id,
      }).then(data => {
        if(data == 1) {
          this.getData();
        }else {
          this.dataDone = true;
          this.binded = false;
        }
      })

    },
    methods: {
      getData() {
        this.$root.post('/getPatientCase', {
          pat_id: this.$route.params.id,
          type: 2
        }).then(data => {

          if(data.base_info.is_married != 3 || data.base_info.is_childbed != 3 || data.base_info.is_drink != 3 || data.base_info.is_smoke != 3 || data.base_info.ser_disease || data.base_info.job || data.base_info.nation) {
            this.showMoreInfo = true;
          }
          this.patientBaseInfo = data.base_info;
          if(parseFloat(this.patientBaseInfo.stature) && parseFloat(this.patientBaseInfo.weight)) {
            let heightM = parseFloat(this.patientBaseInfo.stature) / 100;
            this.patientBaseInfo.BMI = (parseFloat(this.patientBaseInfo.weight) / (heightM * heightM)).toFixed(1);
          }else {
            this.patientBaseInfo.BMI = '-'
          }
          this.records = data.info;
          this.dataDone = true;
        })
      },
      // 跳转病历&问诊单详情
      toDetail(item) {
        switch(parseInt(item.type)) {
          case 1:
            // 跳转首诊记录页面
            this.$router.push({name: 'RecordDetail', params: {id: this.$route.params.id}, query: {type: item.type, id: item.id}});
            break;
          case 2:
            // 跳转问诊单详情
            this.$router.push({name: 'RecordDetail', params: {id: this.$route.params.id}, query: {type: item.type, id: item.id}});
            break;
          case 3:
            // 跳转病历详情
            this.$router.push({name: 'RecordDetail', params: {id: this.$route.params.id}, query: {type: item.type, id: item.prescription_id}});
            break;
        }

      }
    },
    filters: {
      dateFilter(stamp) {
        return moment.unix(stamp).format('YYYY.MM.DD');
      },
      whetherFilter(value) {
        switch(parseInt(value)) {
          case 1: return '是';break;
          case 2: return '否';break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/ConsultingRoom/record.vue